// extracted by mini-css-extract-plugin
module.exports = {"slide":"ImageUpload_slide_2vPxf","slide-reverse":"ImageUpload_slide-reverse_3qw2u","wrap":"ImageUpload_wrap_2Hyz5"};